import React from 'react';
import styles from './CarteiraDocumentos.module.css';

interface DocumentoItemProps {
  documento: {
    key: string;
    titulo: string;
    subtitulo: string;
    referenciaDocumento: string;
    id: number;
  };
  integranteId: string;
  onVisualizarClick: (integranteId: string, tipoDoc: string, referenciaDocumento: string) => void;
  onExcluirClick: (integranteId: string, tipoDoc: string, id: number) => void;
}

const DocumentoItem: React.FC<DocumentoItemProps> = ({
  documento,
  integranteId,
  onVisualizarClick,
  onExcluirClick,
}) => {
  return (
    <div className={styles.documentoItem}>
      <div className={styles.documentoInfo}>
        <span className={styles.documentoTitulo}>{documento.titulo}</span>
        <span className={styles.documentoSubtitulo}>{documento.subtitulo}</span>
      </div>
      <div className={styles.documentoActions}>
        <button
          className={`${styles.documentoButton} ${styles.hasDocument}`}
          onClick={() => onVisualizarClick(integranteId, documento.key, documento.referenciaDocumento)}
        >
          <i className="fas fa-eye"></i>
        </button>
        <button
          className={styles.documentoButton}
          onClick={() => onExcluirClick(integranteId, documento.key, documento.id)}
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>
    </div>
  );
};

export default DocumentoItem;
